R.isString = R.pipe(R.type, R.equals("String"))